"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageType;
(function (MessageType) {
    MessageType[MessageType["Sigon"] = 1] = "Sigon";
    MessageType[MessageType["Packet"] = 2] = "Packet";
    MessageType[MessageType["SyncTick"] = 3] = "SyncTick";
    MessageType[MessageType["ConsoleCmd"] = 4] = "ConsoleCmd";
    MessageType[MessageType["UserCmd"] = 5] = "UserCmd";
    MessageType[MessageType["DataTables"] = 6] = "DataTables";
    MessageType[MessageType["Stop"] = 7] = "Stop";
    MessageType[MessageType["StringTables"] = 8] = "StringTables";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
//# sourceMappingURL=Message.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@demostf/demo.js/build/Data/Message.js
// module id = 0
// module chunks = 0